import { Button, ModalIsland } from "@saviynt/design-system";
import { type Dispatch, type SetStateAction } from "react";
import { useIntl } from "react-intl";
import { useDeleteSavedView } from "../../../../hooks/usePolicySaveFilterView";
import { parseError } from "../../../PoliciesFindingsList/utils";

interface DeleteViewModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  viewData: { name: string; id: number };
}

export default function DeleteViewModal({
  isOpen,
  setIsOpen,
  viewData,
}: DeleteViewModalProps) {
  const intl = useIntl();
  const { mutate } = useDeleteSavedView({
    onSuccess: () => {
      handleClose();
    },
    onError: (error: unknown) => {
      console.log("====Error in Delete view", parseError(error).message);
    },
  });

  const handleClose = () => setIsOpen(false);

  const handleDelete = () => {
    mutate(viewData.id);
  };

  return (
    <ModalIsland
      kind="warning"
      alertTitle={intl.formatMessage({
        description:
          "Alert title asking for confirmation to delete a saved NHI inventory view",
        defaultMessage: "Delete View?",
        id: "vkqmAU",
      })}
      alertSubtitle={intl.formatMessage(
        {
          id: "s3j+of",
          defaultMessage: 'Do you want to delete "{name}"?',
          description:
            "Confirmation message asking if user wants to delete the specified NHI inventory view",
        },
        { name: viewData.name },
      )}
      onClose={handleClose}
      isOpen={isOpen}
      primaryButton={
        <Button kind="outlined" size="medium" onClick={handleDelete}>
          {intl.formatMessage({
            description:
              "Button text to confirm deletion of the NHI inventory view",
            defaultMessage: "Delete View",
            id: "/ZOjlp",
          })}
        </Button>
      }
      secondaryButton={
        <Button kind="ghost" size="medium" onClick={handleClose}>
          {intl.formatMessage({
            id: "J43tlp",
            defaultMessage: "Cancel",
            description:
              "Button text to cancel deletion of the NHI inventory view",
          })}
        </Button>
      }
    />
  );
}
